<!--
  演示环境的导出预览：导出成功后把这张表弹出来。
  蒙版和面板是兄弟节点 —— 点蒙版关弹窗，点面板本身不关。
-->
@if (payload(); as data) {
  <div class="demo-export-preview-mask" (click)="close()"></div>

  <section
    class="demo-export-preview"
    role="dialog"
    aria-modal="true"
    aria-label="导出表格预览"
  >
    <header class="demo-export-preview-head">
      <span class="demo-export-preview-file">
        <span class="demo-export-preview-file-icon" aria-hidden="true">X</span>
        <span class="demo-export-preview-file-name">{{ data.fileName }}</span>
      </span>
      <span class="demo-export-preview-tag">演示数据</span>
      <button
        class="demo-export-preview-close"
        type="button"
        aria-label="关闭预览"
        (click)="close()"
      >
        <svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true">
          <path
            d="M6 6 L18 18 M18 6 L6 18"
            fill="none"
            stroke="currentColor"
            stroke-width="2.4"
            stroke-linecap="round"
          />
        </svg>
      </button>
    </header>

    <div class="demo-export-preview-body">
      <table class="demo-export-preview-grid">
        <thead>
          <tr>
            <th class="demo-export-preview-corner" scope="col"></th>
            @for (header of data.headers; track $index) {
              <th scope="col">{{ header }}</th>
            }
          </tr>
        </thead>
        <tbody>
          @for (row of data.rows; track $index; let rowIndex = $index) {
            <tr>
              <th class="demo-export-preview-rowno" scope="row">{{ rowIndex + 1 }}</th>
              @for (cell of row; track $index) {
                <td [title]="cell">{{ cell }}</td>
              }
            </tr>
          }
        </tbody>
      </table>
    </div>

    <footer class="demo-export-preview-foot">
      <span class="demo-export-preview-sheet">{{ data.sheetName }}</span>
      <span class="demo-export-preview-hint"> 已下载到本机，这里是同一张表 </span>
      <button class="demo-export-preview-ok" type="button" (click)="close()">关闭</button>
    </footer>
  </section>
}
